import { render, staticRenderFns } from "./appoinmentType.vue?vue&type=template&id=79e6f088&"
import script from "./appoinmentType.vue?vue&type=script&lang=js&"
export * from "./appoinmentType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports